import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { InternalFormFieldGroup } from './InternalFormFieldGroup';
export const FormFieldGroup = (_a) => {
    var { children, className, header } = _a, props = __rest(_a, ["children", "className", "header"]);
    return (_jsx(InternalFormFieldGroup, Object.assign({ className: className, header: header }, props, { children: children })));
};
FormFieldGroup.displayName = 'FormFieldGroup';
//# sourceMappingURL=FormFieldGroup.js.map